/**
 * Build information, generated at build time by vite.config.ts and also served by the
 * backend at /api/version (neurotune/version.py::BuildInfo).
 */
export interface IBuildInfo {
    version: string;
    commit: string | null;
    pipeline_id: string | null;
    builder: string;
    ref: string | null;
    dirty: boolean;
    official: boolean;
    built_at: string | null;
}

declare const __BUILD_INFO__: IBuildInfo | undefined;

/**
 * Returns the build info baked into this frontend bundle. __BUILD_INFO__ is only defined
 * by Vite, so e.g. under jest an "unknown" build is returned instead.
 */
export const getFrontendBuildInfo = (): IBuildInfo => {
    if (typeof __BUILD_INFO__ !== "undefined") {
        return __BUILD_INFO__;
    }
    return {
        version: "unknown",
        commit: null,
        pipeline_id: null,
        builder: "Local build",
        ref: null,
        dirty: false,
        official: false,
        built_at: null,
    };
};

/**
 * Formats build info as the About box lines, same format as NDC:
 *   Version M.m.p
 *   (8af2f59e.2931258977)
 *   GitLab CI: develop
 * The build line is omitted for official release builds.
 */
export const formatBuildInfo = (info: IBuildInfo): string[] => {
    const id = [info.commit ?? "unknown", info.pipeline_id].filter(Boolean).join(".");
    const lines = [`Version ${info.version}`, `(${id})`];
    if (!info.official) {
        lines.push(`${info.builder}: ${info.ref ?? "unknown"}${info.dirty ? ".dirty" : ""}`);
    }
    return lines;
};
